import { API } from 'aws-amplify';

const updateListing = async listing => {
  try {
    const data = await API.put('agentbuzz', 'listings', {
      body: createListingData(listing),
    });
    // const updatedListing = ''; //TODO create proper shape

    return {
      status: true,
      result: data,
    };
  } catch (error) {
    return {
      status: false,
      result: error,
    };
  }
};

export { updateListing };

function createListingData(data) {
  const l = data.listing;
  let emailsToNotify = [];
  for (let i = 0; i < l.emailsToNotify.length; i++) {
    const emailVal = l.emailsToNotify[i].value;
    if (emailVal === '') {
      continue;
    }
    emailsToNotify.push(emailVal);
  }

  const listing = {
    listingId: data.listingId,
    agentId: data.agentId,
    agentPhoneNumber: `+1${formatNumber(l.textAlertNotification.value)}`,
    isTextAlertNotification: l.textAlertNotification.isChecked,
    localPhoneNumber: data.localoneNumber,
    teamId: data.teamId,
    agentName: data.agentName,
    agentEmail: data.agentEmail,
    status: data.status,
    title: l.title.value || null,
    address: {
      line1: l.line1.value || null,
      line2: l.line2.value || null,
      city: l.city.value || null,
      state: l.state.value || null,
      zip: l.zip.value || null,
    },
    details: {
      bedrooms: l.bedrooms.value || null,
      bathrooms: l.bathrooms.value || null,
      unitSize: l.unitSize.value || null,
      propertySize: l.propertySize.value || null,
      price: l.price.value || null,
    },
    shortUrl: l.shortUrl || null,
    additionalInfo: l.additionalInfo.value || null,
    website: l.website.value || null,
    smsResponse: data.smsResponse || null, // response to be sent to the lead
    emailsToNotify: !emailsToNotify[0] ? [] : emailsToNotify, // by default it has user's email, creating the listing
    //emailsToNotify: emailsToNotify || null,
  };

  return listing;
}

function formatNumber(numText) {
  const validDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const formatted = numText
    .split('')
    .filter(char => {
      return validDigits.includes(char);
    })
    .join('');
  return formatted;
}



// WEBPACK FOOTER //
// ./src/services/listing/updateListing.js